const updateClient = (state, payload) => {
  var clients = state.clients
  const client = clients.find(e => e.id == payload.id)
  client.name = payload.name
  client.phone = payload.phone
  client.country_code = payload.country_code

  return [...clients]
}

const clients = (state = {}, {type, payload}) => {
  switch (type) {
    case 'CLIENTS.INIT':
      return {...state, clients: payload.clients, page: 1, totalCount: payload.totalCount, perPage: payload.perPage, isLoading: false}
    case 'CLIENTS.RECEIVED':
      return {...state, ...payload}
    case 'CLIENTS.CLIENT_UPDATE':
      return {...state, clients: updateClient(state, payload), isLoading: false}
    case 'CLIENTS.SET_LOADING':
      return {...state, isLoading: payload}
    default:
      return state
  }
}
  
export default clients
